var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36914 12C9.68285 12 12.3691 9.31371 12.3691 6C12.3691 2.68629 9.68285 0 6.36914 0C3.05543 0 0.369141 2.68629 0.369141 6C0.369141 9.31371 3.05543 12 6.36914 12Z",
    fill: "url(#paint0_linear_3730:13717)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.30081 6.21131C2.84565 6.74651 4.3905 6.93745 5.86591 6.21131C7.34132 5.48518 9.44739 5.00784 10.6769 5.16695C11.0956 5.2294 11.51 5.31732 11.918 5.43021C11.7236 4.04679 11.018 2.7864 9.94019 1.89758C8.8624 1.00876 7.49071 0.556029 6.09559 0.628653C4.70047 0.701278 3.3832 1.29399 2.40353 2.28991C1.42385 3.28584 0.852889 4.61268 0.803223 6.00881C0.944978 6.08113 1.10988 6.13899 1.30081 6.21131Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.01172 7.58513C1.92879 9.76064 4.1014 11.5427 6.35212 11.5427C7.93457 11.5253 9.67324 10.6546 10.4948 9.56391C10.7841 8.34887 8.22387 9.80982 6.35212 9.78667C4.02618 9.83585 1.54402 6.51184 1.01172 7.58513Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3730:13717",
    x1: 6.27367,
    y1: 0.39055,
    x2: 6.46171,
    y2: 11.2536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB7B76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0016"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationRed);
export default __webpack_public_path__ + "static/media/notificationRed.e0f08b3bb3924e3d572ca892cdbae4ab.svg";
export { ForwardRef as ReactComponent };